import { render, staticRenderFns } from "./ProductVideoDialog.vue?vue&type=template&id=7cb04c98"
import script from "./ProductVideoDialog.vue?vue&type=script&lang=js"
export * from "./ProductVideoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports